import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import Layout from '../../components/Layout';
import Title from '../../components/Title';
import FormComponent from '../../components/Form';
import FormSnackbar from '../../components/FormSnackbar';
import useCases from '../../useCases';
import Button from '../../components/Button';
import Spinner from '../../components/Spinner';
import { useMediaQuery } from 'react-responsive';
import { Images } from '../../themes';
import {
  Container,
  ContainerSuccess,
  ButtonContainer,
  Paragraph,
  SnackbarContainer,
  BackButton,
  TitleSuccess,
} from './styles';

export default function Form({ lead }) {
  const {register, handleSubmit, errors} = useForm();
  const [fetching, setFetching] = useState(false);
  const [defaultValues, setDefaultValues] = useState(lead);
  const [error, setError] = useState(null);
  const [count, setCount] = useState(null);
  const isMobile = useMediaQuery({ query: '(max-width: 960px)' });
  
  useEffect(() => {
    const timer = count > 0 && setInterval(
      () => setCount(count - 1), 
      1000
    );
    return () => {
      if (count === 1) { 
        window.location.href = '/';
      }

      clearInterval(timer)
    };
  }, [count]);

  const onSubmit = async formData => {
    setFetching(true);
    const result = await useCases.saveLead(formData);
    setFetching(false);

    result.success 
      ? setCount(10) 
      : setError(result.data[0]);
  };

  useEffect(() => {
    setDefaultValues(lead);
  }, [lead]);

  return (
    <Layout activeRoute="activate" mapImageOnBackground={!isMobile}>
      {count === null ? (
        <Container>
          <Title>
            Get Started with <highlight>InStation</highlight>
          </Title>
          <FormComponent
            defaultValues={defaultValues}
            register={register}
            errors={errors}
          />

          <ButtonContainer>
            <Paragraph>You will receive instructions on the next steps in your email</Paragraph>
            {fetching ? (
              <Spinner size={{ width: 210, height: 47 }} />
            ) : (
              <Button
                onClick={handleSubmit(onSubmit)}
                icon={Images.icons.instation}
                alt={'InStation logo'}
                text={'Get Started'}
              />
            )}
          </ButtonContainer>

          {!!error && (
            <SnackbarContainer>
              <FormSnackbar message={error.detail} />
            </SnackbarContainer>
          )}
        </Container>
      ) : (
        <ContainerSuccess>
          <TitleSuccess>
            Thanks for applying to <highlight>InStation</highlight>, we will get in touch by email
          </TitleSuccess>
          <ButtonContainer>
            <BackButton href="/" title="Back to the landing page">
              Back to the landing page
            </BackButton> 
            <Paragraph>
              We will redirect you in {count} seconds
            </Paragraph>
          </ButtonContainer>
        </ContainerSuccess>
      )}
    </Layout>
  );
}

Form.propTypes = {
  lead: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    company: PropTypes.string,
    phone: PropTypes.string,
  }),
};
